import {
  GET_SOCIETY_ROLES,
  GET_SOCIETY_ROLE_DETAILS,
  CREATE_SOCIETY_ROLE,
  UPDATE_SOCIETY_ROLE,
  DELETE_SOCIETY_ROLE,
  ASSIGN_ROLE_PERMISSIONS,
  GET_PERMISSION_CATALOG,
  GET_PERMISSION_CATALOG_GROUPED,
  CLEAR_SOCIETY_ROLE_DETAILS,
} from '../../../actions/index.types';

export const getSocietyRoles = (data) => ({ type: GET_SOCIETY_ROLES, data });
export const getSocietyRoleDetails = (data) => ({ type: GET_SOCIETY_ROLE_DETAILS, data });
export const createSocietyRole = (data) => ({ type: CREATE_SOCIETY_ROLE, data });
export const updateSocietyRole = (data) => ({ type: UPDATE_SOCIETY_ROLE, data });
export const deleteSocietyRole = (data) => ({ type: DELETE_SOCIETY_ROLE, data });
export const assignRolePermissions = (data) => ({ type: ASSIGN_ROLE_PERMISSIONS, data });
export const getPermissionCatalog = (data) => ({ type: GET_PERMISSION_CATALOG, data });
export const getPermissionCatalogGrouped = (data) => ({ type: GET_PERMISSION_CATALOG_GROUPED, data });
export const clearSocietyRoleDetails = () => ({ type: CLEAR_SOCIETY_ROLE_DETAILS });
